import { useRollbar } from '@rollbar/react'
import { PageLayout } from 'components'
import { SupportedChainsWrapper } from 'components/SupportedChainsWrapper'
import { useEffect } from 'react'
import { getEnv } from 'utils'
import { Borrow } from './Borrow'

export const BorrowPage = () => {
  const rollbar = useRollbar()

  useEffect(() => {
    if (!rollbar) return

    try {
      window.Intercom('boot', {
        api_base: 'https://api-iam.intercom.io',
        app_id: getEnv('REACT_APP_INTERCOM_APP_ID'),
      })
    } catch (err) {
      rollbar.error('Intercom failed to boot', err)
    }
  }, [rollbar])

  return (
    <SupportedChainsWrapper functionality="Borrow" supportedChains={[1, 137, 80001, 5]}>
      <PageLayout>
        <Borrow />
      </PageLayout>
    </SupportedChainsWrapper>
  )
}

export default BorrowPage
